import { useRedirect } from "react-admin";
import { useSearchParams } from "react-router-dom";

export const LogoutPage = () => {
	const [searchParams] = useSearchParams();
	const redirect = useRedirect();

	const redirectUrl = searchParams.get("redirect_url");

	if (redirectUrl) {
		redirect(redirectUrl);
	} else {
		redirect("/");
	}
	return null;
};
